import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  titleLink: {
    color: '#8D1A3F',
    '&:hover': {
      textDecoration: 'underline !important',
    },
  },
}));
